export default __webpack_public_path__ + "static/media/exp-pro-frise2.fb139098.mp4";